import { apiService } from './apiService';
import {
  UserMeetingPreferences,
  MeetingExperience,
  MeetingIntent,
  MeetingNeed,
  MeetingProfile,
} from '@/types/meetings';

interface GetPreferencesResponse {
  success: boolean;
  preferences: UserMeetingPreferences | null;
}

interface SavePreferencesResponse {
  success: boolean;
  preferences: UserMeetingPreferences;
}

export interface SavePreferencesPayload {
  meeting_experience: MeetingExperience;
  meeting_intent: MeetingIntent;
  meeting_need: MeetingNeed;
  derived_profile: MeetingProfile;
}

class MeetingPreferencesService {
  private cached: UserMeetingPreferences | null | undefined = undefined;
  private suggestedIds: string[] | null = null;

  setSuggestedMeetingIds(ids: string[]): void {
    this.suggestedIds = ids;
  }

  getSuggestedMeetingIds(): string[] | null {
    return this.suggestedIds;
  }

  async getPreferences(): Promise<UserMeetingPreferences | null> {
    if (this.cached !== undefined) {
      return this.cached;
    }
    try {
      const response = await apiService.get<GetPreferencesResponse>(
        '/api/user/meeting-preferences'
      );
      if (response.success && response.data) {
        this.cached = response.data.preferences;
        return this.cached;
      }
      this.cached = null;
      return null;
    } catch (error) {
      console.error('[MeetingPreferencesService] Error fetching preferences:', error);
      this.cached = null;
      return null;
    }
  }

  async savePreferences(payload: SavePreferencesPayload): Promise<UserMeetingPreferences | null> {
    try {
      const response = await apiService.post<SavePreferencesResponse>(
        '/api/user/meeting-preferences',
        payload
      );
      if (response.success && response.data?.preferences) {
        this.cached = response.data.preferences;
        return this.cached;
      }
      return null;
    } catch (error) {
      console.error('[MeetingPreferencesService] Error saving preferences:', error);
      return null;
    }
  }

  deriveProfile(
    experience: MeetingExperience,
    intent: MeetingIntent
  ): MeetingProfile {
    if (experience === 'for_someone') return 'codependente';
    return intent;
  }

  clearCache(): void {
    this.cached = undefined;
  }
}

export const meetingPreferencesService = new MeetingPreferencesService();
export default meetingPreferencesService;
